/* Botón "Subir" de la PLP (paridad MX, tarea B2).
   Muestra .tbl-back-to-top cuando el scroll supera 1.5 pantallas y vuelve
   arriba al hacer clic (sin animación si el usuario pidió reducir movimiento).
   Guard global: el grid puede incluirse más de una vez en una página. */
(() => {
  if (window.__tblBackToTopInit) return;
  window.__tblBackToTopInit = true;

  const init = () => {
    const buttons = document.querySelectorAll('.tbl-back-to-top');
    if (!buttons.length) return;

    let ticking = false;
    const update = () => {
      ticking = false;
      const visible = window.scrollY > window.innerHeight * 1.5;
      buttons.forEach((btn) => {
        btn.hidden = !visible;
      });
    };
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    };

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    buttons.forEach((btn) => {
      btn.addEventListener('click', () => {
        window.scrollTo({ top: 0, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      });
    });

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
